<ng-container *ngIf="!isPinned; else content">
    <agpr-button
        [id]="'quotaUsagePanel_unpinned_toggleButton'"
        class="agpr-quotaUsagePanel-toggleButton agpr-quotaUsagePanel-collapsed"
        [style]="buttonTypes.icon"
        icon="fa-solid fa-angles-left"
        tooltip="Social.intelligence.themeManagement.quotaUsagePanel.headerLabel"
        tooltipPosition="left"
        srLabel="Social.intelligence.themeManagement.quotaUsagePanel.headerLabel"
        (click)="openQuotaUsageWidget()"
    ></agpr-button>
</ng-container>


<ng-template #content let-id>
    <div class="agpr-quotaUsagePanel">
        <agpr-quota-usage-dashboard [expanded]="false" [showBanner]="false" [quotaType]="quotaType"></agpr-quota-usage-dashboard>
    </div>
</ng-template>
